import { useRef, useState, useLayoutEffect, } from 'react';

const Tooltip = ({ children, tooltipContent, align = 'center' }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState('top');
  const tooltipRef = useRef(null);
  const triggerRef = useRef(null);

  const bgStyle = 'bg-[#111]';

  // Make popup show over the element if it is too close to the bottom of the screen
  useLayoutEffect(() => {
    if (showTooltip && tooltipRef.current && triggerRef.current) {
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const triggerRect = triggerRef.current.getBoundingClientRect();

      //if (triggerRect.top - tooltipRect.height - 8 < 0) {
      if (triggerRect.top < window.innerHeight/2) {
        setPosition('bottom');
      } else {
        setPosition('top');
      }
    }
  }, [showTooltip]);

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      ref={triggerRef}
    >
      {children}
      {(showTooltip && tooltipContent) &&
        <div
          ref={tooltipRef}
          className={`absolute ${align === 'left' ? 'left-0' : 'left-1/2 translate-x-[-50%]'} ${position === 'top' ? 'bottom-full mb-3' : 'top-full mt-3'} z-[50]`}
        >
          <div className={`relative animate-up-fade w-max max-w-xs px-3 py-2 text-white border border-[#555] ${bgStyle} rounded-lg drop-shadow-[0_6px_4px_rgba(20,20,20,1)]`}>
            {/* Content */}
            <div className="relative z-[1] font-normal shadow">{tooltipContent}</div>
            {/* Arrow */}
            <div className={`absolute z-[0] ${align === 'left' ? 'left-0 translate-x-[15px]' : 'left-1/2 translate-x-[-50%]'} w-4 h-4 min-w-4 min-h-4 ${bgStyle} border border-[#555] rotate-45 ${position === 'top' ? 'top-full translate-y-[-55%]' : 'bottom-full translate-y-[55%]'} `} />
            {/* Arrow mask */}
            <div className={`absolute z-[0] ${align === 'left' ? 'left-0 translate-x-[15px]' : 'left-1/2 translate-x-[-50%]'} w-8 h-4 min-w-8 min-h-4 ${bgStyle} ${position === 'top' ? 'top-full translate-y-[-100%]' : 'bottom-full translate-y-[100%]'} `} />
            {/* Filler between the popup and childen so that user can move there cursor to the popup without triggering a mouseout event */}
            <div className={`absolute w-full h-4 ${position === 'top' ? 'top-full' : 'bottom-full'}`}></div>
          </div>
        </div>
      }
    </div>
  );
};

export default Tooltip;
